<template>
  <div>
    <!-- Sub data processors table -->
    <div class="card pagination-margin"
         qid="sub-data-processors-section"
         v-if="showTable"
         id="update_subdata_processors"
    >
      <div class="card-body" :class="{'pr-0 pl-0': showOnTask}">
        <div class="row">
          <div class="col-sm-6">
            <div class="float-left">
              <h5 class="mb-2" qid="systems-table-title" v-if="!showOnTask">
                {{ $t('maintenance.third_parties.sub_data_processors.title') }}
              </h5>

              <div class="mt-2" v-if="!showOnTask">
                <span class="cursor-pointer task-label-open mr-2"
                      v-if="getTask('update_subdata_processors')"
                >
                  <UpdateSingleTaskModal
                      :task="getTask('update_subdata_processors')"
                      @reloadContent="reloadContent"
                      :editIcon="true"
                  ></UpdateSingleTaskModal>
                </span>
                <span v-if="getGuide('update_subdata_processors')">
                  <GuideButton :guide="getGuide('update_subdata_processors')"></GuideButton>
                </span>
              </div>
            </div>
          </div>
          <div class="col-sm-6 text-right">
            <span class="btn btn-success float-right"
                    @click="showAddThirdPartyModal()"
                    qid="create-button"
                    v-if="isGranted([permissions.ACTIVITY_SYSTEM_CREATE, permissions.ACTIVITY_SYSTEM_CREATE_OWN], thirdParty) && (!getClient.parent || (getClient.parent && thirdParty.partition))"
            >
              <font-awesome-icon icon="plus"/> {{ $t('maintenance.third_parties.sub_data_processors.create_button') }}
            </span>
            <span v-if="isGranted(permissions.SYSTEM_CREATE) && (!getClient.parent || (getClient.parent && thirdParty.partition))" qid="system-create-button">
              <VendorCreateForm></VendorCreateForm>
            </span>
          </div>
        </div>

        <table class="table table-responsive-md table-list-secondary">
          <thead>
          <tr>
            <th scope="col"
                class="cursor-pointer"
                @click="selectSort('name')"
                qid="sort-s-name"
            >
              {{ $t('maintenance.third_parties.table.name') }}
              <span class="ml-2">
                <font-awesome-icon class="text-muted" icon="sort" v-if="selectedSort !== 'name'"/>
                <font-awesome-icon icon="caret-down" v-if="selectedDirection === 'desc' && selectedSort === 'name'"/>
                <font-awesome-icon icon="caret-up" v-if="selectedDirection === 'asc' && selectedSort === 'name'"/>
              </span>
            </th>
            <th scope="col">
              {{ $t('activities.third_party.table.processing_role') }}
            </th>
            <th scope="col">
              {{ $t('activities.table.countries') }}
            </th>
            <th scope="col">
              {{ $t('maintenance.third_parties.sub_data_processors.business_classification') }}
            </th>
            <th scope="col">
              {{ $t('maintenance.third_parties.sub_data_processors.privacy_classification') }}
            </th>
            <th scope="col"
                class="cursor-pointer"
                @click="selectSort('updated_at')"
                qid="sort-s-name"
            >
              {{ $t('system.last_updated') }}
              <span class="ml-2">
                <font-awesome-icon class="text-muted" icon="sort" v-if="selectedSort !== 'updated_at'"/>
                <font-awesome-icon icon="caret-down" v-if="selectedDirection === 'desc' && selectedSort === 'updated_at'"/>
                <font-awesome-icon icon="caret-up" v-if="selectedDirection === 'asc' && selectedSort === 'updated_at'"/>
              </span>
            </th>
            <th width="280"></th>
          </tr>
          </thead>
          <tbody>
            <tr v-for="object in sTableItems">
              <td>
                <span class="cursor-pointer mr-2 float-left" v-if="object.vendor && object.vendor.name">
                  <Avatar :object="object.vendor" size="xs"></Avatar>
                </span>
                <span v-if="object.vendor && object.vendor.name"
                      qid="system-name"
                >
                  {{ object.vendor.name }}
                </span>
              </td>
              <td>
                <span v-if="object.processing_role" class="text-normal">
                  <span v-if="object.processing_role == 'Data processor'">
                    <font-awesome-icon icon="microchip" class="mr-2"/>
                    {{ $t('activities.processing_role.data_processor_label') }}
                  </span>
                  <span v-if="object.processing_role == 'Data controller'">
                    <font-awesome-icon icon="joystick" class="mr-2"/>
                    {{ $t('activities.processing_role.data_controller_label') }}
                  </span>
                  <span v-if="object.processing_role == 'Joint controller'">
                    <font-awesome-icon icon="handshake" class="mr-2"/>
                    {{ $t('activities.processing_role.joint_controller_label') }}
                  </span>
                </span>
                <span class="text-muted cursor-pointer btn btn-sm btn-link mr-2 ml-2"
                      qid="edit-activity-modal"
                      @click="showEditProcessingRoleModal(object)"
                      v-if="isGranted([permissions.ACTIVITY_SYSTEM_DELETE, permissions.ACTIVITY_SYSTEM_DELETE_OWN], thirdParty) && (!getClient.parent || (getClient.parent && thirdParty.partition))"
                >
                  <font-awesome-icon icon="pen" />
                </span>
              </td>
              <td>
                <span v-if="(object.countries_with_flag && object.countries_with_flag.length) || (object.vendor && object.vendor.country_with_flag && object.vendor.country_with_flag.name)">
                  <span class="mr-1" v-for="country in getReducedCountries(object)" qid="p-countries-list">
                    <span class="badge">
                      <img v-bind:src="country.flag" height="13" class="align-baseline mr-1" /> <span>{{country.name}}</span>
                    </span>
                  </span>
                  <span v-if="object.countries_with_flag && object.countries_with_flag.length && object.countries_with_flag.length > 1"
                        class="badge cursor-pointer"
                        @click="openCountriesModal(object)"
                  >
                    <span v-if="object.vendor && object.vendor.country_with_flag.name">+ {{ object.countries_with_flag.length }}</span>
                    <span v-if="object.vendor && !object.vendor.country_with_flag.name">+ {{ object.countries_with_flag.length - 1 }}</span>
                  </span>
                  <span v-if="object.countries_with_flag && object.countries_with_flag.length && object.countries_with_flag.length == 1 && object.vendor && object.vendor.country_with_flag && object.vendor.country_with_flag.name"
                        class="badge cursor-pointer"
                        @click="openCountriesModal(object)"
                  >
                    + {{ object.countries_with_flag.length }}
                  </span>
                </span>
                <span class="text-muted cursor-pointer btn btn-sm btn-link mr-2 ml-2"
                      qid="edit-activity-modal"
                      @click="showEditCountryModal(object)"
                      v-if="isGranted([permissions.ACTIVITY_SYSTEM_DELETE, permissions.ACTIVITY_SYSTEM_DELETE_OWN], thirdParty) && (!getClient.parent || (getClient.parent && thirdParty.partition))"
                >
                  <font-awesome-icon icon="pen" />
                </span>
              </td>
              <td>
                <span @click="showDataObjectsModal(object, 'business')"
                      class="mr-1 cursor-pointer btn btn-link p-0 cursor-pointer"
                      v-if="object.business_classification != null && object.business_classification != false"
                >
                  <span class="badge">
                    <span class="mr-2">
                      <font-awesome-icon icon="exclamation-triangle" class="risk-1" v-if="object.business_classification == 4"/>
                      <font-awesome-icon icon="exclamation-triangle" class="risk-9" v-if="object.business_classification == 3"/>
                      <font-awesome-icon icon="exclamation-triangle" class="risk-16" v-if="object.business_classification < 3"/>
                    </span>
                    {{ businessClassificationItems[object.business_classification - 1].name }}
                  </span>
                </span>
                <span @click="showDataObjectsModal(object, 'business')"
                      class="mr-1 cursor-pointer btn btn-link p-0 cursor-pointer"
                      v-if="object.business_classification == null && object.data_objects.length"
                >
                  <span class="badge text-muted">
                    {{ $t('system.none') }}
                  </span>
                </span>
              </td>
              <td>
                <span @click="showDataObjectsModal(object, 'privacy')"
                      class="mr-1 cursor-pointer btn btn-link p-0 cursor-pointer"
                      v-if="object.privacy_classification != null && object.privacy_classification != false"
                >
                  <span class="badge">
                    <span class="mr-2">
                      <font-awesome-icon icon="exclamation-triangle" class="risk-0" v-if="object.privacy_classification == 5"/>
                      <font-awesome-icon icon="exclamation-triangle" class="risk-1" v-if="object.privacy_classification == 4"/>
                      <font-awesome-icon icon="exclamation-triangle" class="risk-9" v-if="object.privacy_classification == 3"/>
                      <font-awesome-icon icon="exclamation-triangle" class="risk-16" v-if="object.privacy_classification < 3"/>
                    </span>
                    {{ privacyClassificationItems[object.privacy_classification - 1].name }}
                  </span>
                </span>
              </td>
              <td>
                <span class="text-normal">
                  {{ object.updated_at | formatDate }}
                </span>
              </td>
              <td align="right">
                <span class="btn btn-secondary"
                      v-if="isGranted([permissions.ACTIVITY_SYSTEM_EDIT, permissions.ACTIVITY_SYSTEM_EDIT_OWN], thirdParty) && (!getClient.parent || (getClient.parent && thirdParty.partition))"
                      qid="system-copy-link"
                      @click="showDataMappingModal(object)"
                >
                  {{ $t('activities.tab.data_mapping') }}
                </span>
                <span
                      @click="openViewSModal(object)"
                      qid="system-name-link"
                      class="btn btn-view"
                >
                  <font-awesome-icon icon="eye"/>
                </span>
                <span class="btn btn-delete"
                      qid="delete-thirdParty-modal"
                      @click="showSConfirmDeleteModal(object)"
                      v-if="isGranted([permissions.ACTIVITY_SYSTEM_DELETE, permissions.ACTIVITY_SYSTEM_DELETE_OWN], thirdParty) && (!getClient.parent || (getClient.parent && thirdParty.partition))"
                >
                  <font-awesome-icon icon="trash-alt" />
                </span>
              </td>
            </tr>
            <tr v-if="!sLoading && !sTableItems.length" qid="no-results-row" class="text-center">
              <td colspan="10">
                <h5 class="mt-3">
                  {{ $t('system.no_results') }}
                </h5>
              </td>
            </tr>
          </tbody>
        </table>
      </div>

      <div class="card-body">
        <div class="pagination row">
          <div class="col-md-6">
            <div class="row">
              <div class="float-left">
                <span class="text-muted pagination-counter">
                  {{ $t('pagination.entries_per_page') }}:
                </span>
              </div>
              <div class="float-left">
                <multiselect
                  v-model="perPage"
                  :options="perPageOptions"
                  track-by="value"
                  label="value"
                  :select-label="$t('system.dropdown_select_label')"
                  :selected-label="$t('system.dropdown_selected_label')"
                  :deselect-label="$t('system.dropdown_deselect_label')"
                  qid="create-org-form-organization-level"
                  @select="perPageChanged"
                  :placeholder="selectedPerPage"
                  @remove="perPageRemoved"
                ></multiselect>
              </div>
            </div>
          </div>
          <div class="col-md-6">
            <b-pagination
                class="float-right"
                v-model="currentPage"
                :total-rows="rows"
                :per-page="selectedPerPage"
                aria-controls="my-table"
                @change="pageChanged"
                limit="1"
            >
              <span class="text-muted" slot="first-text"><font-awesome-icon icon="angle-double-left"/></span>
              <span class="text-muted" slot="prev-text"><font-awesome-icon icon="angle-left"/></span>
              <span class="text-muted" slot="next-text"><font-awesome-icon icon="angle-right"/></span>
              <span class="text-muted" slot="last-text"><font-awesome-icon icon="angle-double-right"/></span>
              <div slot="ellipsis-text">
                <b-spinner small type="grow"></b-spinner>
                <b-spinner small type="grow"></b-spinner>
                <b-spinner small type="grow"></b-spinner>
              </div>
              <span class="text-muted" slot="page" slot-scope="{ page, active }">
                <span v-if="active">{{getPerPage}}</span>
              </span>
            </b-pagination>
          </div>
        </div>
      </div>

    </div>


    <!-- Delete sub-data processor modal template -->
    <b-modal ref="delete-ac" hide-footer>
      <div class="d-block text-center">
        <h4 qid="delete-ac-title">
          {{ $t('activities.system.delete.title') }}
        </h4>
      </div>
      <h5 class="text-center">
        {{ $t('activities.system.delete.description') }}
        <span v-if="itemToDelete.vendor">{{ itemToDelete.vendor.name }}</span>
      </h5>
      <h5 class="text-center">
        {{ $t('activities.system.delete.are_you_sure') }}
      </h5>
      <div class="text-center">
        <b-button class="mt-3"
                  variant="secondary"
                  @click="hideSConfirmDeleteModal"
                  qid="delete-ac-cancel-button"
        >
          {{ $t('activities.system.delete.cancel') }}
        </b-button>
        <b-button @click="confirmDeleteS(itemToDelete)"
                  class="mt-3 ml-3"
                  variant="success"
                  qid="delete-ac-submit-button"
        >
          {{ $t('activities.system.delete.submit') }}
        </b-button>
      </div>
    </b-modal>


    <!-- Data mapping modal -->
    <b-modal ref="data-mapping"
             @hide="hideDataMappingModal"
             modal-class="task-modal mapping-modal"
    >
    <template #modal-header="{ close }">
      <div class="" style="width: 100%;">
        <span @click="hideDataMappingModal" class="btn btn-secondary cursor-pointer float-right ml-2 mr-0">
          <font-awesome-icon icon="times"/>
        </span>
        <h5 class="mb-1 text-center">
          {{ $t('activities.tab.data_mapping') }}
          {{ $t('system.from') }}
          <span v-if="itemObject.third_party">
            <span class="ml-1">
              <Avatar :object="itemObject.third_party.vendors[0]" size="xs"></Avatar>
            </span>
            {{ itemObject.third_party.vendors[0].name }}
          </span>
          {{ $t('system.to') }}
          <span class="mb-4" v-if="itemObject && itemObject.vendor">
            <span class="ml-1">
              <Avatar :object="itemObject.vendor" size="xs"></Avatar>
            </span>
            {{ itemObject.vendor.name }}
          </span>
        </h5>
      </div>
    </template>
      <b-alert v-if="error.length"
               show
               variant="danger"
               qid="create-ac-error"
      >
        {{ error }}
      </b-alert>

      <b-form @submit="dataMappingFormSubmit" qid="create-p-form"  v-if="itemObject && itemObject.vendor">
        <div>
          <!-- <div class="row">
            <div class="col">

            </div>
            <div class="col-1">

            </div>
            <div class="col">
              <b-form-group>
                <label qid="edit-tp-processing-role-label">
                  {{ $t('systems.third_parties.create.processing_role_label') }}
                </label>
                <span class="text-red">*</span>
                <multiselect
                    v-model="processingRole"
                    :options="processingRoleItems"
                    :select-label="$t('system.dropdown_select_label')"
                    :selected-label="$t('system.dropdown_selected_label')"
                    :deselect-label="$t('system.dropdown_deselect_label')"
                    :placeholder="$t('systems.third_parties.create.processing_role_placeholder')"
                    label="text"
                    track-by="value"
                    qid="edit-tp-form-processing-role"
                >
                  <template slot="option" slot-scope="props">
                    <span v-if="props.option.value == 'Data processor'">
                      <font-awesome-icon icon="microchip" class="mr-2"/>
                    </span>
                    <span v-if="props.option.value == 'Data controller'">
                      <font-awesome-icon icon="joystick" class="mr-2"/>
                    </span>
                    <span v-if="props.option.value == 'Joint controller'">
                      <font-awesome-icon icon="handshake" class="mr-2"/>
                    </span>
                    {{ $t('maintenance.third_parties.processing_role.' + $options.filters.slugify(props.option.value)) }}
                  </template>
                  <template slot="singleLabel" slot-scope="props">
                    <span v-if="props.option.value == 'Data processor'">
                      <font-awesome-icon icon="microchip" class="mr-2"/>
                    </span>
                    <span v-if="props.option.value == 'Data controller'">
                      <font-awesome-icon icon="joystick" class="mr-2"/>
                    </span>
                    <span v-if="props.option.value == 'Joint controller'">
                      <font-awesome-icon icon="handshake" class="mr-2"/>
                    </span>
                    {{ $t('maintenance.third_parties.processing_role.' + $options.filters.slugify(props.option.value)) }}
                  </template>
                </multiselect>
              </b-form-group>
            </div>
          </div> -->

          <div class="mb-4 mt-3">
            <span class="btn btn-secondary cursor-pointer" @click="showCopyFromModal(itemObject)">
              <font-awesome-icon icon="plus"/>
              {{ $t('activities.system.copy.system_label') }}
            </span>
            <span class="btn btn-secondary cursor-pointer" @click="toggleSearch()">
              <font-awesome-icon icon="search"/>
              {{ $t('system.show_hide_search') }}
            </span>
          </div>

          <div class="row mb-3" v-if="showSearch">
            <div class="col">
              <b-form-group>
                <label qid="edit-lb-category-label">
                  {{ $t('activities.system.create.data_point_label') }}
                </label>
                <div>
                  <b-form-input
                    type="text"
                    v-model="keywordValue"
                    qid="search-do-input"
                    v-on:input="debounceInput"
                    :placeholder="$t('activities.third_party.data_objects.search_placeholder')"
                  ></b-form-input>
                </div>
              </b-form-group>
            </div>
            <!-- <div class="col-1">

            </div>
            <div class="col">
              <b-form-group>
                <label qid="edit-s-data-label">
                  {{ $t('activities.system.create.data_label') }}
                </label>
                <div>
                  <b-form-input
                    type="text"
                    v-model="keywordFilterValue"
                    qid="search-do-input"
                    v-on:input="filterSelectedData"
                    :placeholder="$t('activities.third_party.data_objects.filter_placeholder')"
                  ></b-form-input>
                </div>
              </b-form-group>
            </div> -->
          </div>

          <div class="row">
            <div class="col">
              <!-- <div>
                <label class="float-right cursor-pointer ml-3"
                       @click="unselectAll"
                       qid="system-unselect-button"
                >
                  {{ $t('system.unselect_all') }}
                </label>
                <label class="float-right cursor-pointer"
                       @click="selectAll"
                       qid="system-select-button"
                >
                  {{ $t('system.select_all') }}
                </label>
              </div>
              <br> -->

              <div @click="showRelatedFunction()" class="mb-1 cursor-pointer">
                <font-awesome-icon :icon="['far', 'square']" style="color:#BCDAD4;margin-bottom:1px;" v-if="!showOnlyRelated"/>
                <font-awesome-icon icon="check-square" style="color:#2DBA9B;margin-bottom:1px;" v-if="showOnlyRelated" />
                {{ $t('system.show_only_related_data') }}
                (<span id="related-number" style="display:inline-block;text-align:center;">{{ selectedDataObjects.length }}</span>)
              </div>
              <div class="form-control scrollable-height-430 pt-3"
                   qid="tp-source-data-objects"
              >
                <div>
                  <div class="" v-for="(item, index) in DOItems">
                    <div class="data-object-div" :id="'data-object-' + index"
                         @click="selectDataObject(index, item)"
                         :class="{'data-object-div-selected': item.selected}"
                    >
                      <b-popover
                          :target="'data-object-' + index"
                          boundary="viewport"
                          triggers="hover"
                          placement="top"
                          :delay="{ show: 500, hide: 0 }"
                      >
                        <div v-if="item.name" class="mt-2">
                          <span class="text-bold">
                            {{ $t('maintenance.data_objects.table.name') }}:
                          </span>
                          <br>
                          {{ item.name }}
                          <br>
                        </div>

                        <div v-if="item.description" class="mt-2">
                          <span class="text-bold">
                            {{ $t('maintenance.data_objects.table.description') }}:
                          </span>
                          <br>
                          {{ item.description | truncate(200)}}
                          <br>
                        </div>

                        <div v-if="item.category" class="mt-2">
                          <span class="text-bold">
                            {{ $t('maintenance.data_objects.table.category') }}:
                          </span>
                          <br>
                          <span v-if="item.category" class="mr-3">
                            <font-awesome-icon icon="shapes" class="mr-1" />
                            {{ item.category }}
                          </span>
                          <br>
                        </div>

                        <div v-if="item.classification" class="mt-2">
                          <span class="text-bold">
                            {{ $t('maintenance.data_objects.table.classification') }}:
                          </span>
                          <br>
                          <span class="badge pl-0 mr-3">
                            <font-awesome-icon icon="exclamation-triangle" class="risk-0 mr-2" v-if="item.classification == 'N/A'"/>
                            <font-awesome-icon icon="exclamation-triangle" class="risk-1 mr-2" v-if="item.classification == 'Generic art. 6'"/>
                            <font-awesome-icon icon="exclamation-triangle" class="risk-9 mr-2" v-if="item.classification == 'National identification number art. 87'"/>
                            <font-awesome-icon icon="exclamation-triangle" class="risk-16 mr-2" v-if="item.classification == 'Sensitive art. 9' || item.classification == 'Criminal art. 10'"/>
                            {{ $t('classification.' + $options.filters.slugify(item.classification)) }}
                          </span>
                          <br>
                        </div>

                        <div v-if="item.business_classification" class="mt-2">
                          <span class="text-bold">
                            {{ $t('maintenance.data_objects.table.business_classification') }}:
                          </span>
                          <br>
                          <span class="badge pl-0 mr-3" v-if="item.business_classification">
                            <font-awesome-icon icon="exclamation-triangle" class="risk-1 mr-2" v-if="item.business_classification == 'Unclassified'"/>
                            <font-awesome-icon icon="exclamation-triangle" class="risk-9 mr-2" v-if="item.business_classification == 'Confidential'"/>
                            <font-awesome-icon icon="exclamation-triangle" class="risk-16 mr-2" v-if="item.business_classification == 'Top secret' || item.business_classification == 'Secret'"/>
                            {{ $t('classification.' + $options.filters.slugify(item.business_classification)) }}
                          </span>
                          <br>
                        </div>

                        <div v-if="item.tags_translated && item.tags_translated.length">
                          <span class="text-bold">
                            {{ $t('processes.table.tags') }}:
                          </span>
                          <br>
                          <span v-for="tag in item.tags_translated" qid="p-tags-list">
                            <span class="badge" :title="tag.name_translated">
                              <font-awesome-icon icon="tag"/>
                              {{ tag.name_translated }}
                            </span>
                          </span>
                          <br>
                        </div>

                      </b-popover>

                      <font-awesome-icon :icon="['far', 'square']" style="color:#BCDAD4;" v-if="!item.selected" class="mr-2"/>
                      <font-awesome-icon icon="check-square" style="color:#2DBA9B;" v-if="item.selected" class="mr-2"/>
                      <!-- <b-form-checkbox
                        v-model="item.selected"
                        name="checkbox-disable"
                        :value="true"
                        :unchecked-value="false"
                        style="display:inline;pointer-events:none;"
                      ></b-form-checkbox> -->
                      <span>{{ item.name | truncate(20)}}</span>
                    </div>
                  </div>
                  <!-- <div class="table-item-div cursor-pointer"
                       v-for="(item, index) in DOItems"
                       @click="selectDataObject(index, item)"
                       :class="{'table-item-div-selected': item.selected}"
                  >
                    <div class="text-bold">
                      {{ item.name }}
                    </div>
                    <div>
                      <span v-if="item.category" class="mr-3">
                        <font-awesome-icon icon="shapes" class="mr-1" />
                        {{ item.category }}
                      </span>
                      <span class="mr-3">
                        <span v-if="item.tags_translated && item.tags_translated.length" qid="activity-tags-list">
                          <span v-for="tag in getReducedTags(item.tags_translated)" :title="tag.name_translated" qid="p-tags-list">
                            <span class="badge" :title="tag.name_translated">
                              <font-awesome-icon icon="tag"/>
                              {{ tag.name_translated | truncate(35) }}
                            </span>
                          </span>
                          <span v-if="item.tags_translated.length > 1"
                                class="badge cursor-pointer"
                                @click="openTagsModal(item, $event)"
                          >
                            <font-awesome-icon icon="tags"/>
                            + {{ item.tags_translated.length - 1 }}
                          </span>
                        </span>
                      </span>
                      <span class="badge pl-0 mr-3">
                        <font-awesome-icon icon="exclamation-triangle" class="risk-0 mr-2" v-if="item.classification == 'N/A'"/>
                        <font-awesome-icon icon="exclamation-triangle" class="risk-1 mr-2" v-if="item.classification == 'Generic art. 6'"/>
                        <font-awesome-icon icon="exclamation-triangle" class="risk-9 mr-2" v-if="item.classification == 'National identification number art. 87'"/>
                        <font-awesome-icon icon="exclamation-triangle" class="risk-16 mr-2" v-if="item.classification == 'Sensitive art. 9' || item.classification == 'Criminal art. 10'"/>
                        {{ $t('classification.' + $options.filters.slugify(item.classification)) }}
                      </span>
                      <span class="badge pl-0 mr-3" v-if="item.business_classification">
                        <font-awesome-icon icon="exclamation-triangle" class="risk-1 mr-2" v-if="item.business_classification == 'Unclassified'"/>
                        <font-awesome-icon icon="exclamation-triangle" class="risk-9 mr-2" v-if="item.business_classification == 'Confidential'"/>
                        <font-awesome-icon icon="exclamation-triangle" class="risk-16 mr-2" v-if="item.business_classification == 'Top secret' || item.business_classification == 'Secret'"/>
                        {{ $t('classification.' + $options.filters.slugify(item.business_classification)) }}
                      </span>
                    </div>
                  </div> -->
                  <div class="text-center table-item-div" v-if="!loading && !DOItems.length">
                    <h5 class="mt-3">
                      {{ $t('system.no_results') }}
                    </h5>
                  </div>
                </div>
              </div>
              <!-- <div class="text-muted mt-2 mb-3">
                {{ $t('activities.system.create.tip_add_label') }}
              </div> -->
            </div>
            <!-- <div class="col-1">
              <b-button class="mt-200 btn-block"
                        variant="success"
                        @click="addData"
                        size="sm"
                        qid="system-select-button"
              >
                {{ $t('system.add') }} >
              </b-button>
            </div> -->
            <!-- <div class="col">
              <div>
                <label class="float-right cursor-pointer ml-3"
                       @click="unrelateAll"
                       qid="system-unselect-button"
                >
                  {{ $t('system.unselect_all') }}
                </label>
                <label class="float-right cursor-pointer"
                       @click="relateAll"
                       qid="system-select-button"
                >
                  {{ $t('system.select_all') }}
                </label>
                <br>
                <div class="form-control scrollable-height-430" qid="tp-source-data-objects">
                  <div>
                    <div class="table-item-div cursor-pointer"
                         v-for="(itemDO, index) in allDataObjectsFiltered"
                         @click="handleDO(index, itemDO)"
                         :class="{'table-item-div-selected': itemDO.related}"
                    >
                      <div class="text-bold">
                        {{ itemDO.name }}
                      </div>
                      <div>
                        <span v-if="itemDO.category" class="mr-3">
                          <font-awesome-icon icon="shapes" class="mr-1" />
                          {{ itemDO.category }}
                        </span>
                        <span class="mr-3">
                          <span v-if="itemDO.tags_translated && itemDO.tags_translated.length" qid="activity-tags-list">
                            <span v-for="tag in getReducedTags(itemDO.tags_translated)" :title="tag.name_translated" qid="p-tags-list">
                              <span class="badge" :title="tag.name_translated">
                                <font-awesome-icon icon="tag"/>
                                {{ tag.name_translated | truncate(35) }}
                              </span>
                            </span>
                            <span v-if="itemDO.tags_translated.length > 1"
                                  class="badge cursor-pointer"
                                  @click="openTagsModal(itemDO, $event)"
                            >
                              <font-awesome-icon icon="tags"/>
                              + {{ itemDO.tags_translated.length - 1 }}
                            </span>
                          </span>
                        </span>
                        <span class="badge pl-0 mr-3">
                          <font-awesome-icon icon="exclamation-triangle" class="risk-0 mr-2" v-if="itemDO.classification == 'N/A'"/>
                          <font-awesome-icon icon="exclamation-triangle" class="risk-1 mr-2" v-if="itemDO.classification == 'Generic art. 6'"/>
                          <font-awesome-icon icon="exclamation-triangle" class="risk-9 mr-2" v-if="itemDO.classification == 'National identification number art. 87'"/>
                          <font-awesome-icon icon="exclamation-triangle" class="risk-16 mr-2" v-if="itemDO.classification == 'Sensitive art. 9' || itemDO.classification == 'Criminal art. 10'"/>
                          {{ $t('classification.' + $options.filters.slugify(itemDO.classification)) }}
                        </span>
                        <span class="badge pl-0 mr-3" v-if="itemDO.business_classification">
                          <font-awesome-icon icon="exclamation-triangle" class="risk-1 mr-2" v-if="itemDO.business_classification == 'Unclassified'"/>
                          <font-awesome-icon icon="exclamation-triangle" class="risk-9 mr-2" v-if="itemDO.business_classification == 'Confidential'"/>
                          <font-awesome-icon icon="exclamation-triangle" class="risk-16 mr-2" v-if="itemDO.business_classification == 'Top secret' || itemDO.business_classification == 'Secret'"/>
                          {{ $t('classification.' + $options.filters.slugify(itemDO.business_classification)) }}
                        </span>
                      </div>
                    </div>
                    <div class="text-center table-item-div" v-if="!allDataObjectsFiltered.length">
                      <h5 class="mt-3">
                        {{ $t('system.no_results') }}
                      </h5>
                    </div>
                  </div>
                </div>
                <div class="text-muted mt-2">
                  {{ $t('activities.system.create.tip_label') }}
                </div>
                <div>
                  <span class="color-primary mr-2 legend-icon-container">
                    <span class="legend legend-primary"></span>
                  </span>
                  <span>{{ $t('system.related') }}</span>
                  <span class="color-white ml-4 mr-2 legend-icon-container">
                    <span class="legend legend-white"></span>
                  </span>
                  <span>{{ $t('system.not_related') }}</span>
                </div>
              </div>
            </div> -->
          </div>
        </div>
      </b-form>

      <template #modal-footer="{ close }">
        <div class="" style="width: 100%;">
          <div class="alert alert-menu-color color-secondary mb-0" role="alert">
            <div class="row">
              <div class="col-sm-6">
                <div v-if="isGranted(permissions.DATA_OBJECT_CREATE)"
                     qid="data-object-system-create-button"
                     class="text-left mt-2"
                >
                  <DataObjectCreateForm @updated="loadDO()"></DataObjectCreateForm>
                </div>
              </div>
              <div class="col-sm-6">
                <div class="text-right">
                  <b-button class="mt-2 mb-2"
                            variant="secondary"
                            @click="mappingHide"
                            qid="create-ac-cancel-button"
                  >
                    {{ $t('activities.third_party.create.cancel') }}
                  </b-button>
                  <b-button type="submit"
                            class="mt-2 mb-2 ml-3 mr-0"
                            :disabled="buttonDisabled"
                            variant="success"
                            @click="dataMappingFormSubmit()"
                            qid="create-ac-submit-button"
                  >
                    <span v-if="buttonDisabled" class="mr-1">
                      <font-awesome-icon icon="spinner" size="sm" class="fa-spin"/>
                    </span>
                    {{ $t('activities.third_party.create.submit') }}
                  </b-button>
                </div>
              </div>
            </div>
          </div>
        </div>
      </template>
    </b-modal>


    <!-- Copy from modal -->
    <b-modal ref="copy-from"
             @hide="hideCopyFromModal"
             size="sm"
             modal-class="task-modal mapping-modal"
    >

      <template #modal-header="{ close }">
        <div class="" style="width: 100%;">
          <span @click="copyHide" class="btn btn-secondary cursor-pointer float-right ml-2 mr-0">
            <font-awesome-icon icon="times"/>
          </span>
          <h5 class="mb-1 text-center">
            {{ $t('activities.system.copy.modal_title') }}
          </h5>
          <div class="row mt-2 pt-4 pb-1" v-if="getGuide('copy_dataflow')">
            <div class="col-sm-12">
              <b-form-group>
                <div class="">
                  <div v-if="getGuide('copy_dataflow')" class="mb-2">
                    <GuideButton :guide="getGuide('copy_dataflow')"></GuideButton>
                  </div>
                  <div v-if="wpGuide && wpGuide.id" class="guide-content-container">
                    <p v-if="!showFullCopyGuideDescription" v-html="wpGuide.excerpt.rendered"></p>
                    <p v-if="showFullCopyGuideDescription" v-html="wpGuide.content.rendered"></p>

                    <div class="text-center mt-3" @click="showFullCopyGuideDescription=!showFullCopyGuideDescription">
                      <span class="cursor-pointer" v-if="!showFullCopyGuideDescription">
                        <span class="mr-2">
                          {{ $t('system.view_more') }}
                        </span>
                        <font-awesome-icon icon="chevron-down"/>
                      </span>
                      <span class="cursor-pointer" v-if="showFullCopyGuideDescription">
                        <span class="mr-2">
                          {{ $t('system.view_less') }}
                        </span>
                        <font-awesome-icon icon="chevron-up"/>
                      </span>
                    </div>
                  </div>
                </div>
              </b-form-group>
            </div>
          </div>
        </div>

      </template>

      <b-alert v-if="error.length"
               show
               variant="danger"
               qid="create-ac-error"
      >
        {{ error }}
      </b-alert>

      <b-form @submit="copyFromFormSubmit" qid="create-ac-form">
        <div>
          <div class="row mb-3">
            <div class="col">
              <b-form-group>
                <label qid="create-ac-pg-label">
                  {{ $t('activities.system.copy.system_label') }}
                </label>
                <multiselect
                    v-model="selectedTP"
                    :options="copyOptions"
                    :placeholder="$t('activities.system.copy.third_party_placeholder')"
                    label="name"
                    :select-label="$t('system.dropdown_select_label')"
                    :selected-label="$t('system.dropdown_selected_label')"
                    :deselect-label="$t('system.dropdown_deselect_label')"
                    @select="selectCopyItem"
                    @remove="deselectCopyItem"
                    track-by="id"
                    qid="create-ac-form-ac"
                >
                  <template slot="option" slot-scope="props">
                    <Avatar :object="props.option.vendor" size="xs"></Avatar>
                    <span class="ml-2">
                      {{ props.option.name }}
                    </span>
                  </template>
                  <template slot="singleLabel" slot-scope="props">
                    <Avatar :object="props.option.vendor" size="xs"></Avatar>
                    <span class="ml-2">
                      {{ props.option.name }}
                    </span>
                  </template>
                </multiselect>
              </b-form-group>
            </div>
          </div>
          <div class="row">
            <div class="col">

              <div>
                <label class="float-right cursor-pointer"
                       @click="selectAllCopy"
                       qid="system-select-button"
                >
                  {{ $t('system.select_all') }}
                </label>
              </div>
              <br>

              <div class="form-control scrollable-height-430 pt-3"
                   qid="tp-source-data-objects"
              >
                <div>
                  <div class="" v-for="(item, index) in copyItems">
                    <div class="data-object-div" :id="'copy-object-' + index"
                         @click="selectCopyObject(index, item)"
                         :class="{'data-object-div-selected': item.selected}"
                    >
                      <b-popover
                          :target="'copy-object-' + index"
                          boundary="viewport"
                          triggers="hover"
                          placement="top"
                          :delay="{ show: 500, hide: 0 }"
                      >
                        <div v-if="item.name" class="mt-2">
                          <span class="text-bold">
                            {{ $t('maintenance.data_objects.table.name') }}:
                          </span>
                          <br>
                          {{ item.name }}
                          <br>
                        </div>

                        <div v-if="item.description" class="mt-2">
                          <span class="text-bold">
                            {{ $t('maintenance.data_objects.table.description') }}:
                          </span>
                          <br>
                          {{ item.description | truncate(200)}}
                          <br>
                        </div>

                        <div v-if="item.category" class="mt-2">
                          <span class="text-bold">
                            {{ $t('maintenance.data_objects.table.category') }}:
                          </span>
                          <br>
                          <span v-if="item.category" class="mr-3">
                            <font-awesome-icon icon="shapes" class="mr-1" />
                            {{ item.category }}
                          </span>
                          <br>
                        </div>

                        <div v-if="item.classification" class="mt-2">
                          <span class="text-bold">
                            {{ $t('maintenance.data_objects.table.classification') }}:
                          </span>
                          <br>
                          <span class="badge pl-0 mr-3">
                            <font-awesome-icon icon="exclamation-triangle" class="risk-0 mr-2" v-if="item.classification == 'N/A'"/>
                            <font-awesome-icon icon="exclamation-triangle" class="risk-1 mr-2" v-if="item.classification == 'Generic art. 6'"/>
                            <font-awesome-icon icon="exclamation-triangle" class="risk-9 mr-2" v-if="item.classification == 'National identification number art. 87'"/>
                            <font-awesome-icon icon="exclamation-triangle" class="risk-16 mr-2" v-if="item.classification == 'Sensitive art. 9' || item.classification == 'Criminal art. 10'"/>
                            {{ $t('classification.' + $options.filters.slugify(item.classification)) }}
                          </span>
                          <br>
                        </div>

                        <div v-if="item.business_classification" class="mt-2">
                          <span class="text-bold">
                            {{ $t('maintenance.data_objects.table.business_classification') }}:
                          </span>
                          <br>
                          <span class="badge pl-0 mr-3" v-if="item.business_classification">
                            <font-awesome-icon icon="exclamation-triangle" class="risk-1 mr-2" v-if="item.business_classification == 'Unclassified'"/>
                            <font-awesome-icon icon="exclamation-triangle" class="risk-9 mr-2" v-if="item.business_classification == 'Confidential'"/>
                            <font-awesome-icon icon="exclamation-triangle" class="risk-16 mr-2" v-if="item.business_classification == 'Top secret' || item.business_classification == 'Secret'"/>
                            {{ $t('classification.' + $options.filters.slugify(item.business_classification)) }}
                          </span>
                          <br>
                        </div>

                        <div v-if="item.tags_translated && item.tags_translated.length">
                          <span class="text-bold">
                            {{ $t('processes.table.tags') }}:
                          </span>
                          <br>
                          <span v-for="tag in item.tags_translated" qid="p-tags-list">
                            <span class="badge" :title="tag.name_translated">
                              <font-awesome-icon icon="tag"/>
                              {{ tag.name_translated }}
                            </span>
                          </span>
                          <br>
                        </div>
                      </b-popover>

                      <font-awesome-icon :icon="['far', 'square']" style="color:#BCDAD4;" v-if="!item.selected" class="mr-2"/>
                      <font-awesome-icon icon="check-square" style="color:#2DBA9B;" v-if="item.selected" class="mr-2"/>
                      <!-- <b-form-checkbox
                        v-model="item.selected"
                        name="checkbox-disable"
                        :value="true"
                        :unchecked-value="false"
                        style="display:inline;pointer-events:none;"
                      ></b-form-checkbox> -->
                      <span>{{ item.name | truncate(15)}}</span>
                    </div>
                  </div>
                  <div class="text-center table-item-div" v-if="!loading && !copyItems.length">
                    <h5 class="mt-3">
                      {{ $t('system.no_results') }}
                    </h5>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </b-form>

      <template #modal-footer="{ close }">
        <div class="" style="width: 100%;">
          <div class="alert alert-menu-color color-secondary mb-0" role="alert">
            <div class="row">
              <div class="col-sm-6">

              </div>
              <div class="col-sm-6">
                <div class="text-right">
                  <b-button class="mt-2 mb-2"
                            variant="secondary"
                            @click="copyHide"
                            qid="create-ac-cancel-button"
                  >
                    {{ $t('activities.third_party.create.cancel') }}
                  </b-button>
                  <b-button type="submit"
                            class="mt-2 mb-2 ml-3 mr-0"
                            :disabled="buttonDisabled"
                            variant="success"
                            @click="copyFromFormSubmit()"
                            qid="create-ac-submit-button"
                  >
                    <span v-if="buttonDisabled" class="mr-1">
                      <font-awesome-icon icon="spinner" size="sm" class="fa-spin"/>
                    </span>
                    {{ $t('activities.third_party.create.submit') }}
                  </b-button>
                </div>
              </div>
            </div>
          </div>
        </div>

      </template>
    </b-modal>


    <!-- Add new third party -->
    <b-modal ref="add-third-party" hide-footer @hide="hideAddThirdPartyModal">
      <div class="d-block text-center">
        <h4 qid="add-tp-title">
          {{ $t('maintenance.third_parties.sub_data_processors.create.title') }}
        </h4>
      </div>
      <b-alert v-if="error.length"
               show
               variant="danger"
               qid="create-tp-error"
      >
        {{ error }}
      </b-alert>
      <b-form @submit="tpFormSubmit" qid="create-tp-form">
        <div class="form-container">
          <b-form-group>
            <label qid="create-ac-pg-label">
              {{ $t('activities.third_party.create.vendor_label') }}
            </label>
            <span class="text-red">*</span>
            <multiselect
                v-model="selectedVendor"
                :options="vendors"
                :placeholder="$t('activities.third_party.create.vendor_placeholder')"
                label="name"
                :select-label="$t('system.dropdown_select_label')"
                :selected-label="$t('system.dropdown_selected_label')"
                :deselect-label="$t('system.dropdown_deselect_label')"
                @search-change="loadVendors"
                @select="setCountry"
                @remove="resetCountry"
                track-by="slug"
                qid="create-ac-form-ac"
            >
              <template slot="option" slot-scope="props">
                <Avatar :object="props.option" size="xs"></Avatar>
                <span class="ml-2">
                  {{ props.option.name }}
                </span>
              </template>
              <template slot="singleLabel" slot-scope="props">
                <Avatar :object="props.option" size="xs"></Avatar>
                <span class="ml-2">
                  {{ props.option.name }}
                </span>
              </template>
            </multiselect>
          </b-form-group>

          <div v-if="selectedVendor && selectedVendor.description"
               class="text-center mb-3 mt-4"
          >
            <span class="cursor-pointer">
              <span class="mr-2"
                    @click="showSDescription = !showSDescription"
                    qid="expand-tp-description"
              >
                {{$t('activities.third_party.create.third_party_description_expand')}}
              </span>
              <font-awesome-icon icon="chevron-down" v-if="!showSDescription"/>
              <font-awesome-icon icon="chevron-up" v-if="showSDescription"/>
            </span>
          </div>
          <div v-if="selectedVendor && selectedVendor.description && showSDescription" class="mb-4 mt-2">
            <span class="text-formatted">
              {{ selectedVendor.description }}
            </span>
          </div>

          <b-form-group v-if="selectedVendor && selectedVendor.id">
            <label qid="create-tp-item-label">
              {{ $t('systems.third_parties.create.processing_role_label') }}
            </label>
            <span class="text-red">*</span>
            <multiselect
                v-model="processingRole"
                :options="processingRoleItems"
                :select-label="$t('system.dropdown_select_label')"
                :selected-label="$t('system.dropdown_selected_label')"
                :deselect-label="$t('system.dropdown_deselect_label')"
                :placeholder="$t('systems.third_parties.create.processing_role_placeholder')"
                label="value"
                track-by="value"
                qid="create-tp-form-processing-role"
            >
              <template slot="option" slot-scope="props">
                <span v-if="props.option.value == 'Data processor'">
                  <font-awesome-icon icon="microchip" class="mr-2"/>
                </span>
                <span v-if="props.option.value == 'Data controller'">
                  <font-awesome-icon icon="joystick" class="mr-2"/>
                </span>
                <span v-if="props.option.value == 'Joint controller'">
                  <font-awesome-icon icon="handshake" class="mr-2"/>
                </span>
                {{ $t('maintenance.third_parties.processing_role.' + $options.filters.slugify(props.option.value)) }}
              </template>
              <template slot="singleLabel" slot-scope="props">
                <span v-if="props.option.value == 'Data processor'">
                  <font-awesome-icon icon="microchip" class="mr-2"/>
                </span>
                <span v-if="props.option.value == 'Data controller'">
                  <font-awesome-icon icon="joystick" class="mr-2"/>
                </span>
                <span v-if="props.option.value == 'Joint controller'">
                  <font-awesome-icon icon="handshake" class="mr-2"/>
                </span>
                {{ $t('maintenance.third_parties.processing_role.' + $options.filters.slugify(props.option.value)) }}
              </template>
            </multiselect>
          </b-form-group>
          <b-form-group v-if="selectedVendor && selectedVendor.id">
            <label qid="create-tp-countries-label">
              {{ $t('maintenance.third_parties.create.country_label') }}
            </label>
            <multiselect
                v-model="selectedCountries"
                :options="countries"
                :multiple="true"
                :taggable="false"
                :select-label="$t('system.dropdown_select_label')"
                :selected-label="$t('system.dropdown_selected_label')"
                :deselect-label="$t('system.dropdown_deselect_label')"
                track-by="name"
                :placeholder="$t('maintenance.third_parties.create.country_placeholder')"
                label="name"
                qid="create-tp-countries-select"
            >
            <template slot="tag" slot-scope="props">
              <img v-bind:src="props.option.flag" height="13" class="align-baseline mr-1" />
              <span class="mr-1" v-if="selectedVendor && selectedVendor.country_with_flag" :class="{'text-muted': selectedVendor ? props.option.name == selectedVendor.country_with_flag.name : false}">
                {{ props.option.name }}
              </span>
              <font-awesome-icon
                icon="times"
                v-if="selectedVendor && selectedVendor.country_with_flag ? props.option.name != selectedVendor.country_with_flag.name : false"
                class="cursor-pointer mr-2 text-normal"
                @click="removeCountry(props.option)"
              />
            </template>
            <template slot="option" slot-scope="props">
              <img v-bind:src="props.option.flag" height="13" class="align-baseline mr-1" />
              <span class="ml-1">
                {{ props.option.name }}
              </span>
            </template>
            </multiselect>
          </b-form-group>
        </div>
        <div class="text-right">
          <b-button class="mt-3"
                    variant="secondary"
                    @click="hideAddThirdPartyModal"
                    qid="create-tp-cancel-button"
          >
            {{ $t('systems.third_parties.create.cancel') }}
          </b-button>
          <b-button type="submit"
                    class="mt-3 ml-3"
                    :disabled="buttonDisabled"
                    variant="success"
                    qid="create-tp-submit-button"
          >
            <span v-if="buttonDisabled" class="mr-1">
              <font-awesome-icon icon="spinner" size="sm" class="fa-spin"/>
            </span>
            {{ $t('systems.third_parties.create.submit') }}
          </b-button>
        </div>
      </b-form>
    </b-modal>


    <!-- Show data objects modal -->
    <b-modal ref="view-data-objects" hide-footer @hide="hideDataObjectsModal">
      <div class="d-block text-center mb-3">
        <h4 qid="delete-tp-title" v-if="dataObjectsType == 'business'">
          {{ $t('maintenance.third_parties.sub_data_processors.business_data_objects_title') }}
        </h4>
        <h4 qid="delete-tp-title" v-if="dataObjectsType == 'privacy'">
          {{ $t('maintenance.third_parties.sub_data_processors.privacy_data_objects_title') }}
        </h4>
      </div>
      <div class="mt-4" v-if="dataObjectsType == 'privacy'">
        <div class="mb-3" v-if="privacyArray0.length">
          <h5>
            <font-awesome-icon icon="exclamation-triangle" class="risk-16 mr-2"/>
            {{ $t('classification.sensitive_art._9') }}
          </h5>
          <div class="card-modern pb-3">
            <div v-for="item in privacyArray0" class="mb-2">
              <span>{{ item.name }}</span>
            </div>
          </div>
        </div>
        <div class="mb-3" v-if="privacyArray1.length">
          <h5>
            <font-awesome-icon icon="exclamation-triangle" class="risk-16 mr-2"/>
            {{ $t('classification.criminal_art._10') }}
          </h5>
          <div class="card-modern pb-3">
            <div v-for="item in privacyArray1" class="mb-2">
              <span>{{ item.name }}</span>
            </div>
          </div>
        </div>
        <div class="mb-3" v-if="privacyArray2.length">
          <h5>
            <font-awesome-icon icon="exclamation-triangle" class="risk-9 mr-2"/>
            {{ $t('classification.national_identification_number_art._87') }}
          </h5>
          <div class="card-modern pb-3">
            <div v-for="item in privacyArray2" class="mb-2">
              <span>{{ item.name }}</span>
            </div>
          </div>
        </div>
        <div class="mb-3" v-if="privacyArray3.length">
          <h5>
            <font-awesome-icon icon="exclamation-triangle" class="risk-1 mr-2"/>
            {{ $t('classification.generic_art._6') }}
          </h5>
          <div class="card-modern pb-3">
            <div v-for="item in privacyArray3" class="mb-2">
              <span>{{ item.name }}</span>
            </div>
          </div>
        </div>
        <div class="mb-3" v-if="privacyArray4.length">
          <h5>
            <font-awesome-icon icon="exclamation-triangle" class="risk-0 mr-2"/>
            {{ $t('system.n_a') }}
          </h5>
          <div class="card-modern pb-3">
            <div v-for="item in privacyArray4" class="mb-2">
              <span>{{ item.name }}</span>
            </div>
          </div>
        </div>
      </div>
      <div class="mt-4" v-if="dataObjectsType == 'business'">
        <div class="mb-3" v-if="businessArray0.length">
          <h5>
            <font-awesome-icon icon="exclamation-triangle" class="risk-16 mr-2"/>
            {{ $t('classification.top_secret') }}
          </h5>
          <div class="card-modern pb-3">
            <div v-for="item in businessArray0" class="mb-2">
              <span>{{ item.name }}</span>
            </div>
          </div>
        </div>
        <div class="mb-3" v-if="businessArray1.length">
          <h5>
            <font-awesome-icon icon="exclamation-triangle" class="risk-16 mr-2"/>
            {{ $t('classification.secret') }}
          </h5>
          <div class="card-modern pb-3">
            <div v-for="item in businessArray1" class="mb-2">
              <span>{{ item.name }}</span>
            </div>
          </div>
        </div>
        <div class="mb-3" v-if="businessArray2.length">
          <h5>
            <font-awesome-icon icon="exclamation-triangle" class="risk-9 mr-2"/>
            {{ $t('classification.confidential') }}
          </h5>
          <div class="card-modern pb-3">
            <div v-for="item in businessArray2" class="mb-2">
              <span>{{ item.name }}</span>
            </div>
          </div>
        </div>
        <div class="mb-3" v-if="businessArray3.length">
          <h5>
            <font-awesome-icon icon="exclamation-triangle" class="risk-1 mr-2"/>
            {{ $t('classification.unclassified') }}
          </h5>
          <div class="card-modern pb-3">
            <div v-for="item in businessArray3" class="mb-2">
              <span>{{ item.name }}</span>
            </div>
          </div>
        </div>
        <div class="mb-3" v-if="nullArray.length">
          <h5 class="text-muted">
            {{ $t('system.none') }}
          </h5>
          <div class="card-modern pb-3">
            <div v-for="item in nullArray" class="mb-2">
              <span>{{ item.name }}</span>
            </div>
          </div>
        </div>
      </div>
      <div class="float-right">
        <b-button class="mt-3"
                  variant="success"
                  @click="hideDataObjectsModal"
                  qid="delete-tp-cancel-button"
        >
          {{ $t('maintenance.third_parties.data_objects.close') }}
        </b-button>
      </div>
    </b-modal>


    <!-- View subdata processor modal -->
    <b-modal ref="view-tp" hide-footer @hide="hideViewSModal">
      <div class="d-block text-center">
        <h4 qid="add-io-title">
          {{ $t('maintenance.third_parties.sub_data_processors.view_modal_title') }}
        </h4>
      </div>

      <div v-if="selectedItem && selectedItem.id">

        <label class="mt-3">
          {{ $t('maintenance.third_parties.table.name') }}
        </label>
        <br>
        <span v-if="selectedItem.vendor && selectedItem.vendor.name"
              qid="system-name"
        >
          {{ selectedItem.vendor.name }}
        </span>
        <br>

        <label class="mt-3">
          {{ $t('activities.third_party.table.processing_role') }}
        </label>
        <br>
        <span v-if="selectedItem && selectedItem.processing_role">
          <span class="text-normal">
            <span v-if="selectedItem.processing_role == 'Data processor'">
              <font-awesome-icon icon="microchip" class="mr-2"/>
              {{ $t('activities.processing_role.data_processor_label') }}
            </span>
            <span v-if="selectedItem.processing_role == 'Data controller'">
              <font-awesome-icon icon="joystick" class="mr-2"/>
              {{ $t('activities.processing_role.data_controller_label') }}
            </span>
            <span v-if="selectedItem.processing_role == 'Joint controller'">
              <font-awesome-icon icon="handshake" class="mr-2"/>
              {{ $t('activities.processing_role.joint_controller_label') }}
            </span>
          </span>
        </span>
        <br>

        <label class="mt-3">
          {{ $t('activities.table.countries') }}
        </label>
        <br>
        <span v-if="selectedItem.vendor && selectedItem.vendor.country_with_flag && selectedItem.vendor.country_with_flag.name" qid="modal-organizations-list">
          <span class="badge mb-1 mr-2">
            <img v-bind:src="selectedItem.vendor.country_with_flag.flag" height="13" class="align-baseline mr-1" />
            {{ selectedItem.vendor.country_with_flag.name }}
          </span>
        </span>
        <span v-if="selectedItem && selectedItem.countries_with_flag && selectedItem.countries_with_flag.length" v-for="country in selectedItem.countries_with_flag" qid="modal-organizations-list">
          <span class="badge mb-1 mr-2">
            <img v-bind:src="country.flag" height="13" class="align-baseline mr-1" /> <span>{{country.name}}</span>
          </span>
        </span>
        <br>

        <label class="mt-3">
          {{ $t('maintenance.third_parties.sub_data_processors.business_classification') }}
        </label>
        <br>
        <span
            class="mr-1 p-0"
            v-if="selectedItem.business_classification != null"
        >
          <span class="badge">
            <span class="mr-2">
              <font-awesome-icon icon="exclamation-triangle" class="risk-1" v-if="selectedItem.business_classification == 4"/>
              <font-awesome-icon icon="exclamation-triangle" class="risk-9" v-if="selectedItem.business_classification == 3"/>
              <font-awesome-icon icon="exclamation-triangle" class="risk-16" v-if="selectedItem.business_classification < 3"/>
            </span>
            {{ businessClassificationItems[selectedItem.business_classification - 1].name }}
          </span>
        </span>
        <br>

        <label class="mt-3">
          {{ $t('maintenance.third_parties.sub_data_processors.privacy_classification') }}
        </label>
        <br>
        <span
            class="mr-1 p-0"
            v-if="selectedItem.privacy_classification != null"
        >
          <span class="badge">
            <span class="mr-2">
              <font-awesome-icon icon="exclamation-triangle" class="risk-0" v-if="selectedItem.privacy_classification == 5"/>
              <font-awesome-icon icon="exclamation-triangle" class="risk-1" v-if="selectedItem.privacy_classification == 4"/>
              <font-awesome-icon icon="exclamation-triangle" class="risk-9" v-if="selectedItem.privacy_classification == 3"/>
              <font-awesome-icon icon="exclamation-triangle" class="risk-16" v-if="selectedItem.privacy_classification < 3"/>
            </span>
            {{ privacyClassificationItems[selectedItem.privacy_classification - 1].name }}
          </span>
        </span>
        <br>

      </div>

      <div>
        <b-button class="mt-4 mb-4 float-right"
                  variant="success"
                  @click="hideViewSModal"
                  qid="create-p-cancel-button"
        >
          {{ $t('processes.policies.view.close') }}
        </b-button>
      </div>
    </b-modal>


    <!-- Edit processing role modal -->
    <b-modal ref="edit-processing-role" hide-footer @hide="hideEditProcessingRoleModal">
      <div class="d-block text-center">
        <h4 qid="delete-tp-title">
          {{ $t('maintenance.third_parties.processing_role_modal_title') }}
        </h4>
      </div>
      <b-alert v-if="error.length"
               show
               variant="danger"
               qid="create-p-error"
      >
        {{ error }}
      </b-alert>
      <b-form @submit="editProcessingRoleFormSubmit" qid="create-p-form">
        <div class="form-container">
          <b-form-group>
            <label qid="edit-lb-category-label">
              {{ $t('activities.third_party.create.pr_label') }}
            </label>
            <span class="text-red">*</span>
            <multiselect
                v-model="processingRole"
                :options="processingRoleItems"
                :placeholder="$t('activities.third_party.create.pr_placeholder')"
                label="name"
                :select-label="$t('system.dropdown_select_label')"
                :selected-label="$t('system.dropdown_selected_label')"
                :deselect-label="$t('system.dropdown_deselect_label')"
                track-by="value"
                qid="edit-tp-form-inspection"
            >
              <template slot="option" slot-scope="props">
                <span v-if="props.option.value == 'Data processor'">
                  <font-awesome-icon icon="microchip" class="mr-2"/>
                </span>
                <span v-if="props.option.value == 'Data controller'">
                  <font-awesome-icon icon="joystick" class="mr-2"/>
                </span>
                <span v-if="props.option.value == 'Joint controller'">
                  <font-awesome-icon icon="handshake" class="mr-2"/>
                </span>
                {{ $t('maintenance.third_parties.processing_role.' + $options.filters.slugify(props.option.value)) }}
              </template>
              <template slot="singleLabel" slot-scope="props">
                <span v-if="props.option.value == 'Data processor'">
                  <font-awesome-icon icon="microchip" class="mr-2"/>
                </span>
                <span v-if="props.option.value == 'Data controller'">
                  <font-awesome-icon icon="joystick" class="mr-2"/>
                </span>
                <span v-if="props.option.value == 'Joint controller'">
                  <font-awesome-icon icon="handshake" class="mr-2"/>
                </span>
                {{ $t('maintenance.third_parties.processing_role.' + $options.filters.slugify(props.option.value)) }}
              </template>
            </multiselect>
          </b-form-group>
        </div>
        <div class="text-right">
          <b-button class="mt-3"
                    variant="secondary"
                    @click="hideEditProcessingRoleModal"
                    qid="create-p-cancel-button"
          >
            {{ $t('projects.create.cancel') }}
          </b-button>
          <b-button type="submit"
                    class="mt-3 ml-3"
                    variant="success"
                    :disabled="buttonDisabled"
                    qid="create-p-submit-button"
          >
            <span v-if="buttonDisabled" class="mr-1">
              <font-awesome-icon icon="spinner" size="sm" class="fa-spin"/>
            </span>
            {{ $t('projects.create.submit') }}
          </b-button>
        </div>
      </b-form>
    </b-modal>


    <!-- Edit country modal -->
    <b-modal ref="edit-country" hide-footer @hide="hideEditCountryModal">
      <div class="d-block text-center">
        <h4 qid="delete-tp-title">
          {{ $t('maintenance.third_parties.countries_modal_title') }}
        </h4>
      </div>
      <b-alert v-if="error.length"
               show
               variant="danger"
               qid="create-p-error"
      >
        {{ error }}
      </b-alert>
      <b-form @submit="editCountryFormSubmit" qid="create-p-form">
        <div class="form-container">
          <b-form-group>
            <label qid="create-tp-countries-label">
              {{ $t('maintenance.third_parties.create.country_label') }}
            </label>
            <multiselect
                v-model="selectedCountries"
                :options="countries"
                :multiple="true"
                :taggable="false"
                :select-label="$t('system.dropdown_select_label')"
                :selected-label="$t('system.dropdown_selected_label')"
                :deselect-label="$t('system.dropdown_deselect_label')"
                track-by="name"
                :placeholder="$t('maintenance.third_parties.create.country_placeholder')"
                label="name"
                qid="create-tp-countries-select"
            >
              <template slot="tag" slot-scope="props">
                <img v-bind:src="props.option.flag" height="13" class="align-baseline mr-1" />
                <span class="mr-1" :class="{'text-muted': itemObject.vendor ? props.option.name == itemObject.vendor.country_with_flag.name : false}">
                  {{ props.option.name }}
                </span>
                <font-awesome-icon
                  icon="times"
                  v-if="itemObject.vendor ? props.option.name != itemObject.vendor.country_with_flag.name : false"
                  class="cursor-pointer mr-2 text-normal"
                  @click="removeCountry(props.option)"
                />
              </template>
              <template slot="option" slot-scope="props">
                <img v-bind:src="props.option.flag" height="13" class="align-baseline mr-1" />
                <span class="ml-1">
                  {{ props.option.name }}
                </span>
              </template>
            </multiselect>
          </b-form-group>
        </div>
        <div class="text-right">
          <b-button class="mt-3"
                    variant="secondary"
                    @click="hideEditCountryModal"
                    qid="create-p-cancel-button"
          >
            {{ $t('projects.create.cancel') }}
          </b-button>
          <b-button type="submit"
                    class="mt-3 ml-3"
                    variant="success"
                    :disabled="buttonDisabled"
                    qid="create-p-submit-button"
          >
            <span v-if="buttonDisabled" class="mr-1">
              <font-awesome-icon icon="spinner" size="sm" class="fa-spin"/>
            </span>
            {{ $t('projects.create.submit') }}
          </b-button>
        </div>
      </b-form>
    </b-modal>


    <ShowMoreModal
        :items="selectedItem.countries_with_flag"
        :object="selectedItem"
        :show="showCountriesModal"
        @closeViewModal="closeCountriesModal"
        type="countries_with_flag"
    ></ShowMoreModal>

  </div>

</template>

<script>
  import piincHttp from '@/util/configureAxios.js'
  import Avatar from '@/components/Avatar.vue';
  import roleCheck from "@/util/ACL/roleCheck"
  import ValidationList from '@/views/Validations/ValidationList.vue';
  import ValidationForm from '@/views/Validations/ValidationForm.vue';
  import DataObjectCreateForm from '@/views/DataObjects/DataObjectCreateForm.vue';
  import VendorCreateForm from '@/views/ThirdParty/VendorCreateForm.vue';
  import SystemViewModal from '@/views/Systems/SystemViewModal.vue';
  import UpdateSingleTaskModal from '@/views/Tasks/UpdateSingleTaskModal.vue';
  import GuideButton from '@/components/guide/GuideButton.vue';
  import ShowMoreModal from '@/components/ShowMoreModal.vue';


  export default {
    name: 'SubDataProcessorsTable',
    data: function() {
      return {
        sForm: {
          system_role: '',
          rules_followed: '',
          data_objects: [],
          description: '',
          links: [],
          processing_role: '',
          countries: []
        },

        thirdParty: {},

        // Systems
        sTableItems: [],
        selectedS: [],
        viewSModal: false,
        selectedSSort: '',
        selectedSDirection: '',
        sItems: [],
        sLoading: true,
        loading: true,
        copySystemItems: [],
        sValidationShow: false,
        updateValidationList: false,
        selectedTP: [],
        selectedS: [],
        copyThirdPartyItems: [],

        // categories
        systemRoleItems: [],
        systemRoleInput: '',
        selectedSystemRole: [],

        // Data objects
        allDataObjects: [],
        allDataObjectsFiltered: [],
        dataObjects: [],
        systemDataObjects: [],
        newDataObjects: [],
        DOItems: [],
        selectedDataObjects: [],
        selectedCopyObjects: [],
        copyItems: [],
        availableDataObjects: [],

        error: '',
        loadingItems: false,
        itemToDelete: {},
        itemObject: {},
        reCertificationOptions: [],
        provisioningOptions: [],
        selectedRC: [],
        selectedP: [],
        validationOptions: [],
        validation: {},
        disabledValidationOptions: [],
        showSDescription: false,
        radioOptions: [
          {text: this.$t('system.yes'), value: 1},
          {text: this.$t('system.no'), value: 0}
        ],
        processingRole: [],
        processingRoleItems: [
          { text: this.$t('maintenance.third_parties.processing_role.data_controller'), value: 'Data controller'},
          { text: this.$t('maintenance.third_parties.processing_role.data_processor'), value: 'Data processor'},
          { name: this.$t('activities.processing_role.joint_controller_label'), value: 'Joint controller' }
        ],
        privacyClassificationItems: [
          { name: this.$t('classification.sensitive_art._9'), value: 'Sensitive art. 9' },
          { name: this.$t('classification.criminal_art._10'), value: 'Criminal art. 10' },
          { name: this.$t('classification.national_identification_number_art._87'), value: 'National identification number art. 87' },
          { name: this.$t('classification.generic_art._6'), value: 'Generic art. 6' },
          { name: this.$t('system.n_a'), value: 'N/A' }
        ],
        businessClassificationItems: [
          { name: this.$t('classification.top_secret'), value: 'Top secret' },
          { name: this.$t('classification.secret'), value: 'Secret' },
          { name: this.$t('classification.confidential'), value: 'Confidential' },
          { name: this.$t('classification.unclassified'), value: 'Unclassified' }
        ],

        copyOptions: [],

        // Pagination
        perPageOptions: [
          { name: '10', value: '10' },
          { name: '20', value: '20' },
          { name: '50', value: '50' },
          { name: '100', value: '100' }
        ],
        perPage: '',
        selectedPerPage: "10",
        currentPage: 1,
        totalRows: 0,
        selectedSort: '',
        selectedDirection: '',

        buttonDisabled: false,
        keywordValue: '',
        keywordFilterValue: '',
        showSelectionTable: false,
        selectedFiles: [],
        inputLink: '',
        inputLinkName: '',
        showDocuments: false,
        filteredDataObjects: [],
        showTable: false,
        hideSearch: false,
        showMore: false,
        showSearch: false,
        showOnlyRelated: false,
        page: 1,
        myGuides: [],
        myTasks: [],
        vendors: [],
        selectedVendor: [],
        countries: [],
        selectedCountries: [],
        selectedItem: [],
        showCountriesModal: false,
        dataObjectsType: '',
        privacyArray0: [],
        privacyArray1: [],
        privacyArray2: [],
        privacyArray3: [],
        privacyArray4: [],

        nullArray: [],
        businessArray0: [],
        businessArray1: [],
        businessArray2: [],
        businessArray3: [],
      }
    },
    props: {
      object: {
        type: Object,
        required: true
      },
      showOnTask: {},
      task: {}
    },
    components: {
      Avatar,
      ValidationList,
      ValidationForm,
      DataObjectCreateForm,
      VendorCreateForm,
      SystemViewModal,
      UpdateSingleTaskModal,
      GuideButton,
      ShowMoreModal
    },
    computed: {
      getUser() {
        return this.$store.state.user
      },
      rows() {
        // Use computed value for rows because of dynamic update
        return this.totalRows
      },
      getClient() {
        return this.$store.state.client
      },
      getStorePerPage() {
        return this.$store.state.perPage
      },
      getPerPage() {
        let page = this.currentPage;
        let selectedFrom = (page-1) * Number(this.selectedPerPage) + 1;
        let selectedTo = (page-1) * Number(this.selectedPerPage) + Number(this.selectedPerPage);
        let selectedOf = this.totalRows;

        if(selectedTo > selectedOf){
          selectedTo = selectedOf
        }

        return selectedFrom + " - " + selectedTo + " " + this.$t('system.of') + " " + selectedOf
      },
      getReloadContent() {
        return this.$store.state.updateContent
      },
      getReloadTasks() {
        return this.$store.state.reloadTasks
      }
    },
    watch: {
      // Watch when client changes in store and trigger api reload
      getClient: function () {
        if (this.thirdParty && this.thirdParty.id) {
        //  this.loadSR();
        }
      },
      object: function (newValue) {
        if (newValue && newValue.id) {
          this.thirdParty = newValue
          this.showTable = true;
          this.loadTasks('update_subdata_processors');
          this.loadSubdataProcessors();
        }
      },
      showOnlyRelated: function (newValue) {
        if (newValue) {
          this.keywordValue = ''
          this.selectedDataObjects = _.sortBy(this.selectedDataObjects, 'name');
          this.DOItems =  _.cloneDeep(this.selectedDataObjects);
        } else {
          this.loadDO(this.keywordValue)
        }
      },
      getReloadContent: function () {
        if (!this.showOnTask) {
          if (this.$store.state.updatedObject && this.$store.state.updatedObject.id) {
            if (this.$store.state.updatedObject.id == this.thirdParty.id && this.$store.state.updatedObject.who_am_i == this.thirdParty.who_am_i) {
              this.thirdParty = this.$store.state.updatedObject
            }
          }
          this.reloadContent()
        }
      },
      getReloadTasks: function () {
        if (!this.showOnTask) {
          this.loadTasks('update_subdata_processors')
        }
      },
    },
    methods: {
      debounceInput: _.debounce(function() {
        this.loadDO(this.keywordValue)
      }, 400),
      getTask(code) {
        let existingTask = _.find(this.myTasks, function(object) {
          return object.code == code
        });
        return existingTask
      },
      toggleSearch() {
        this.showSearch = !this.showSearch
      },
      showRelatedFunction() {
        this.showOnlyRelated = !this.showOnlyRelated
      },
      showDataObjectsModal(object, type) {
        let self = this;
        this.selectedS = object

        this.dataObjectsType = type

        this.privacyArray0 = []
        this.privacyArray1 = []
        this.privacyArray2 = []
        this.privacyArray3 = []
        this.privacyArray4 = []

        this.nullArray = []
        this.businessArray0 = []
        this.businessArray1 = []
        this.businessArray2 = []
        this.businessArray3 = []

        if (type == 'business') {
          _.forEach(object.data_objects, function (item) {
            if (item.business_classification == null) {
              self.nullArray.push(item)
            }
            if (item.business_classification == self.businessClassificationItems[0].value) {
              self.businessArray0.push(item)
            }
            if (item.business_classification == self.businessClassificationItems[1].value) {
              self.businessArray1.push(item)
            }
            if (item.business_classification == self.businessClassificationItems[2].value) {
              self.businessArray2.push(item)
            }
            if (item.business_classification == self.businessClassificationItems[3].value) {
              self.businessArray3.push(item)
            }
          })
        }
        if (type == 'privacy') {
          _.forEach(object.data_objects, function (item) {
            if (item.classification == self.privacyClassificationItems[0].value) {
              self.privacyArray0.push(item)
            }
            if (item.classification == self.privacyClassificationItems[1].value) {
              self.privacyArray1.push(item)
            }
            if (item.classification == self.privacyClassificationItems[2].value) {
              self.privacyArray2.push(item)
            }
            if (item.classification == self.privacyClassificationItems[3].value) {
              self.privacyArray3.push(item)
            }
            if (item.classification == self.privacyClassificationItems[4].value) {
              self.privacyArray4.push(item)
            }
          })
        }

        this.$refs['view-data-objects'].show()
      },
      hideDataObjectsModal() {
        this.selectedS = {}

        this.privacyArray0 = []
        this.privacyArray1 = []
        this.privacyArray2 = []
        this.privacyArray3 = []
        this.privacyArray4 = []

        this.businessArray0 = []
        this.businessArray1 = []
        this.businessArray2 = []
        this.businessArray3 = []
        this.dataObjectsType = ''
        this.filteredDataObjects = []
        this.$refs['view-data-objects'].hide()
      },
      selectCopyObject(index, item) {
        // Toggle related/not related property
        item.selected = item.selected ? false : true;
        if (item.selected) {
          let foundItem = false;
          _.forEach(this.selectedCopyObjects, function (object) {
            if (object.id == item.id) {
              foundItem = true
            }
          })

          if (!foundItem) {
            this.selectedCopyObjects.push(item)
          }
        } else {
          let itemIndex = _.findIndex(this.selectedCopyObjects, function(o) { return o.id == item.id; });
          this.selectedCopyObjects.splice(itemIndex, 1);
        }

        this.$set(this.copyItems, index, item)
      },

      showEditProcessingRoleModal(object) {
        this.itemObject = object

        this.processingRole = []
        if (object.processing_role) {
          this.processingRole = _.find(this.processingRoleItems, function(item) {
            return item.value === object.processing_role;
          });
        }

        this.$refs['edit-processing-role'].show()
      },
      hideEditProcessingRoleModal() {
        this.error = ''
        this.itemObject = []
        this.selectedCountries = []
        this.loadSubdataProcessors()
        this.$refs['edit-processing-role'].hide()
      },
      showEditCountryModal(object) {
        let self = this;
        this.itemObject = object

        this.selectedCountries = []

        if (object.vendor && object.vendor.country_with_flag) {
          _.find(self.countries, function(item) {
            if (item.name === object.vendor.country_with_flag.name) {
              item.$isDisabled = true;
              self.selectedCountries.push(item)
            }
          });
        }

        if (object.countries && object.countries.length) {
          _.forEach(object.countries_with_flag, function (value) {
            _.find(self.countries, function(item) {
              if (item.name === value.name) {
                self.selectedCountries.push(item)
              }
            });
          })
        }

        this.$refs['edit-country'].show()
      },
      hideEditCountryModal() {
        this.error = ''
        this.itemObject = []
        this.processingRole = []
        this.loadSubdataProcessors()
        this.resetCountries()
        this.$refs['edit-country'].hide()
      },
      editCountryFormSubmit(evt) {

        let self = this;
        evt.preventDefault();

        this.sForm.countries = [];
        if (this.selectedCountries && this.selectedCountries.length) {
          for (var i = 0; i < this.selectedCountries.length; i++) {
            if (!this.itemObject.vendor || !this.itemObject.vendor.country || (this.itemObject.vendor && this.itemObject.vendor.country && this.itemObject.vendor.country && this.itemObject.vendor.country != this.selectedCountries[i].name)) {
              this.sForm.countries.push(this.selectedCountries[i].name);
            }
          }
        }

        self.sForm.data_objects = []
        _.forEach(this.itemObject.data_objects, function (dataObject) {
          self.sForm.data_objects.push(dataObject.id)
        })

        this.buttonDisabled = true;
        piincHttp.put('/third-parties/' + this.thirdParty.slug + '/subdata-processors/' + this.itemObject.id, {
          data_objects: this.sForm.data_objects,
          countries: this.sForm.countries
        }).then(function(response) {
          self.$toastr('success', self.$t('maintenance.third_parties.sub_data_processors.update.success'))
          self.hideEditCountryModal()
          self.$emit('updated');
          self.buttonDisabled = false;
        }, function(error) {
          if (error.status !== 200) {
            self.buttonDisabled = false;
            self.error = error.data.message;
          }
        })
      },
      editProcessingRoleFormSubmit(evt) {

        let self = this;
        evt.preventDefault();

        this.sForm.processing_role = this.processingRole ? this.processingRole.value : '';

        self.sForm.data_objects = []
        _.forEach(this.itemObject.data_objects, function (dataObject) {
          self.sForm.data_objects.push(dataObject.id)
        })

        if (this.processingRole && this.processingRole.value) {
          this.buttonDisabled = true;
          piincHttp.put('/third-parties/' + this.thirdParty.slug + '/subdata-processors/' + this.itemObject.id, {
            data_objects: this.sForm.data_objects,
            processing_role: this.sForm.processing_role
          }).then(function(response) {
            self.$toastr('success', self.$t('maintenance.third_parties.sub_data_processors.update.success'))
            self.hideEditProcessingRoleModal()
            self.$emit('updated');
            self.buttonDisabled = false;
          }, function(error) {
            if (error.status !== 200) {
              self.buttonDisabled = false;
              self.error = error.data.message;
            }
          })
        } else {
          this.error = ''
          if (!this.processingRole || (this.processingRole && !this.processingRole.value)) {
            this.error +=  ' ' + this.$t('activities.third_party.create.processing_role_error')
          }
        }
      },
      isOwner(object) {
        let self = this;
        let allow = false;
        let existingUser = _.find(object.users, function(user) {
          return user.id == self.getUser.id
        });

        if (existingUser) {
          allow = true
        } else {
          if (roleCheck('Client admin') || roleCheck('Partition admin')) {
            allow = true
          }
        }

        return allow
      },
      pageChanged(page) {
        // Load Third parties when page changed listener is triggered
        this.loadSubdataProcessors(page)
      },
      perPageChanged(perPage) {
        let self = this;

        self.selectedPerPage = perPage.value
        this.$store.commit('storePerPage', this.selectedPerPage);
        // Load Third parties when page changed listener is triggered
        this.loadSubdataProcessors(1, perPage.value)
      },
      perPageRemoved() {
        let self = this;
        // Load Third parties when page changed listener is triggered
        self.selectedPerPage = self.perPageOptions[0].value
        this.loadSubdataProcessors(1, self.selectedPerPage)

      },
      selectSort(sort) {
        // If old and new sort are same, switch just direction
        if (sort === this.selectedSort) {
          this.selectedDirection = this.selectedDirection === 'desc' ? 'asc' : 'desc';
        } else {
          // If different sort, set sort and set direction to default
          this.selectedDirection = 'desc'
          this.selectedSort = sort;
        }
        this.loadSubdataProcessors();
      },
      removeCountry(item) {
        let selectedItem = item
        let index = _.findIndex(this.selectedCountries, function(object) { return object.name == item.name; });
        this.$set(this.selectedCountries, index, selectedItem)
        // Remove item from selected users array
        this.selectedCountries.splice(index, 1);
      },
      reloadContent() {
        this.loadTasks('update_subdata_processors');
        this.loadSubdataProcessors();
      },
      loadTasks(code) {
        let self = this;
        if (this.getClient.projectModule) {
          piincHttp.get('projects/me/tasks', { params:
            {
              per_page: 1,
              status: 'pending',
              model_type: this.thirdParty.who_am_i,
              model_id: this.thirdParty.id,
              code: code,
              client: this.getClient.slug
            }
          }).then(function(response) {
            self.myTasks = []
            if (response.data.items.length) {
              self.myTasks.push(response.data.items[0])
            }
          }, function() {});
        }
      },
      setValidation(object) {
        this.validation = object
        this.updateValidationList = false;
      },
      getGuide(code) {
        let existingGuide = _.find(this.myGuides, function(object) {
          return object.scope == code && object.type == 'Third party' && object.enabled
        });
        return existingGuide
      },
      loadGuides(code) {
        let self = this;
        let language = localStorage.getItem('lang')? localStorage.getItem('lang') : 'en';

        piincHttp.get('guides', { params:
          {
            per_page: 1,
            language: 'en',
            type: 'Third party',
            scope: code,
            client: this.getClient.slug
          }
        }).then(function(response) {
          if (response.data.items.length) {
            self.myGuides.push(response.data.items[0])
          }
        }, function() {});
      },
      getReducedCountries(object) {
        let reducedCountries = []

        if (object.vendor && object.vendor.country) {
          reducedCountries.push(object.vendor.country_with_flag)
        } else {
          if (object.countries && object.countries.length > 1) {
            reducedCountries = _.cloneDeep(object.countries_with_flag);
            reducedCountries = reducedCountries.slice(0, 1);
          } else {
            reducedCountries = object.countries_with_flag;
          }
        }

        return reducedCountries;
      },
      openCountriesModal(object) {
        this.selectedItem = object
        this.showCountriesModal = true
      },
      closeCountriesModal() {
        this.selectedItem = {}
        this.showCountriesModal = false
      },
      resetFile() {
        let imagefile = document.querySelector('#file');
        imagefile.value = '';
      },
      onFileChange() {
        let files = document.querySelector('#file');
        // in order for v-for to re render, we need to set array to empty
        this.selectedFiles = [];
        // And then push item by item into that array
        for (var i = 0; i < files.files.length; i++) {
          this.selectedFiles.push(files.files[i])
        }
      },
      handleLink() {
        // If there's a link in input, add it to links array
        if (this.inputLink !== '') {
          if (!this.inputLink.startsWith('http')) {
            this.inputLink = 'http://' + this.inputLink
          }
          this.sForm.links.push({url: this.inputLink, name: this.inputLinkName})
          // Reset link input form
          this.inputLink = ''
          this.inputLinkName = ''
        }
      },
      removeLinkItem(index) {
        // Remove link item from the links array
        this.sForm.links.splice(index, 1);
      },
      addData() {
        let self = this;
        _.forEach(this.DOItems, function (item) {
          if (item.selected) {
            self.updateDOList(item)
          }
        })
        this.unselectAll()
        if (this.selectedS && this.selectedS.id) {
          this.selectCopyItem(this.selectedS)
        } else {
          this.loadDO()
        }
      },
      filterSelectedData() {
        let self = this;
        this.allDataObjectsFiltered = [];
        if (self.keywordFilterValue) {
          _.forEach(this.allDataObjects, function (item) {
            if (
              item.name.toLowerCase().indexOf(self.keywordFilterValue.toLowerCase()) !== -1 ||
              (item.category && item.category.toLowerCase().indexOf(self.keywordFilterValue.toLowerCase()) !== -1) ||
              (item.classification && item.classification.toLowerCase().indexOf(self.keywordFilterValue.toLowerCase()) !== -1)
            ) {
              self.allDataObjectsFiltered.push(item)
            }
          })
        } else {
          this.allDataObjectsFiltered = _.cloneDeep(this.allDataObjects);
        }
      },
      resetFields() {
        this.selectedRC = null
        this.selectedP = null
      },
      setValidation(object) {
        this.validation = object
      },
      selectCopyItem(object) {
        this.showMore = false;
        this.hideSearch = true;
        let self = this
        this.DOItems = []
        this.copyItems = []
        let results = object.data_objects
        this.copyItems.push(...object.data_objects)

      },
      deselectCopyItem(object) {
        this.loadDO();
        this.hideSearch = false;
      },
      showDataMappingModal(object) {
        let self = this;
        let inArray = false;
        this.itemObject = object
        this.selectedDataObjects = []
        this.sForm.data_objects = [];
        this.availableDataObjects = [];

        _.forEach(object.data_objects, function (dataObject) {
           dataObject.selected = true;
           self.selectedDataObjects.push(dataObject)
        })
        this.selectedDataObjects = _.sortBy(this.selectedDataObjects, 'name');

        this.loadDO();

        this.$refs['data-mapping'].show()
      },
      hideDataMappingModal() {
        this.error = ''
        this.keywordValue = ''
        this.keywordFilterValue = ''
        this.allDataObjects = []
        this.loadSubdataProcessors()
        this.copySystemItems = []
        this.itemObject = {}
        this.selectedTP = []
        this.hideSearch = false;
        this.$refs['data-mapping'].hide()
      },
      mappingHide() {
        this.$refs['data-mapping'].hide()
      },
      getUniqueCategories(object) {
        let categories = []
        // Loop through all data objects in third party
        if (object.data_objects && object.data_objects.length) {
          _.forEach(object.data_objects, function (item) {
            categories.push(item.classification)
          })
          // Return unique array of categories in data objects
          return _.uniq(categories);
        }
      },
      showAddThirdPartyModal() {
        this.selectedCountries = []
        this.loadVendors();
        this.$refs['add-third-party'].show()
      },
      resetCountries() {
        let self = this;
        _.forEach(this.countries, function (item) {
          item.$isDisabled = false;
        })
      },
      hideAddThirdPartyModal() {
        this.error = ''
        this.selectedVendor = [];
        this.processingRole = [];
        this.selectedCountries = [];
        this.resetCountries()
        this.$refs['add-third-party'].hide()
      },
      setCountry(object) {
        let self = this;
        this.selectedCountries = []

        if (object && object.country_with_flag) {
          _.find(self.countries, function(item) {
            if (item.name === object.country_with_flag.name) {
              item.$isDisabled = true;
              self.selectedCountries.push(item)
            }
          });
        }
      },
      resetCountry(object) {
        let self = this;
        this.selectedCountries = []
      },
      showCopyFromModal(object) {
        let self = this;
        let inArray = false;
        this.itemObject = object
        this.selectedCopyObjects = []
        this.sForm.data_objects = [];
        self.copyOptions = []
        let item = {}

        piincHttp.get('third-parties/' + this.thirdParty.slug + '/subdata-processors', { params:
          {
            client: this.getClient.slug,
            per_page: 50
          }
        }).then(function(response) {
          self.copySystemItems = response.data.items
          _.forEach(self.copySystemItems, function (item) {
            item.name = item.vendor.name
            if (self.itemObject.id != item.id) {
              self.copyOptions.push(item)
            }
          })
        }, function() {});

        this.$refs['copy-from'].show()
      },
      hideCopyFromModal() {
        this.error = ''
        this.keywordValue = ''
        this.copySystemItems = []
        this.copyItems = []
        this.selectedTP = []
        this.hideSearch = false;
        this.loadDO()
        this.$refs['copy-from'].hide()
      },
      copyHide() {
        this.$refs['copy-from'].hide()
      },
      selectAllCopy() {
        let newDataObjectsArray = []
        let self = this;
        _.forEach(this.copyItems, function (item) {
          item.selected = true;
          newDataObjectsArray.push(item)
          self.selectedCopyObjects.push(item)
        })
        this.copyItems = newDataObjectsArray;
      },
      copyFromFormSubmit(evt) {

        let self = this;
        if (evt) {
          evt.preventDefault();
        }

        _.forEach(this.selectedCopyObjects, function (dataObject) {
          if (_.findIndex(self.selectedDataObjects, function(o) { return o.id == dataObject.id; }) == -1) {
            self.selectedDataObjects.push(dataObject)
          }
        })

        self.$refs['copy-from'].hide()
        self.copySystemItems = []
      },
      showSConfirmDeleteModal(object) {
        this.itemToDelete = object
        this.$refs['delete-ac'].show()
      },
      hideSConfirmDeleteModal() {
        this.itemToDelete = {}
        this.loadContent()
        this.$refs['delete-ac'].hide()
      },
      openViewSModal(object) {
        this.selectedItem = object;
        this.$refs['view-tp'].show()
      },
      hideViewSModal() {
        this.selectedItem = {}
        this.$refs['view-tp'].hide()
      },
      setCopy(index, item) {
        // Toggle related/not related property
        item.copy = item.copy ? false : true;
        this.$set(this.availableDataObjects, index, item)
      },
      setAllCopy() {
        this.availableDataObjects = []
        _.forEach(this.selectedS.data_objects, function (item) {
          item.copy = true;
        })
        this.availableDataObjects = this.selectedS.data_objects;
      },
      unsetAllCopy() {
        this.availableDataObjects = []
        _.forEach(this.selectedS.data_objects, function (item) {
          item.copy = false;
        })
        this.availableDataObjects = this.selectedS.data_objects;
      },
      showDataObjects(object) {
        this.availableDataObjects = []
        if (object && object.data_objects && object.data_objects.length) {
          this.availableDataObjects = object.data_objects;
        }
      },
      hideDataObjects() {
        this.availableDataObjects = []
      },
      handleDO(index, item, related) {
        let self = this;

        if (item && item.related && !related) {
          this.removeDataItem(item, related)
        } else {
          if (related == undefined) {
            // Toggle related/not related property
            item.related = item.related ? false : true;
          } else {
            item.related = related
          }

          _.forEach(this.allDataObjects, function (object, objectIndex) {
            if (item.id == object.id) {
              self.$set(self.allDataObjects, objectIndex, item)
            }
          })
          this.$set(this.allDataObjectsFiltered, index, item)

          if (this.selectedS && this.selectedS.id) {
            this.selectCopyItem(this.selectedS)
          } else {
            if (related == undefined) {
              this.loadDO()
            }
          }

        }
      },
      selectDataObject(index, item) {
        // Toggle related/not related property
        item.selected = item.selected ? false : true;
        if (item.selected) {
          let foundItem = false;
          _.forEach(this.selectedDataObjects, function (object) {
            if (object.id == item.id) {
              foundItem = true
            }
          })

          if (!foundItem) {
            this.selectedDataObjects.push(item)
          }
        } else {
          let itemIndex = _.findIndex(this.selectedDataObjects, function(o) { return o.id == item.id; });
          this.selectedDataObjects.splice(itemIndex, 1);
        }

        this.$set(this.DOItems, index, item)
        var element = document.getElementById('related-number');

        element.classList.add("bounce-enter-active");
        setTimeout(function() {
          element.classList.remove("bounce-enter-active");
        }, 700)
      },
      selectAll() {
        let newDataObjectsArray = []
        let self = this;
        _.forEach(this.DOItems, function (item) {
          item.selected = true;
          newDataObjectsArray.push(item)
        })
        this.DOItems = newDataObjectsArray;
      },
      unselectAll() {
        let newDataObjectsArray = []
        let self = this;
        _.forEach(this.DOItems, function (item) {
          item.selected = false;
          newDataObjectsArray.push(item)
        })
        this.DOItems = newDataObjectsArray;
      },
      relateAll() {
        let self = this;
        let newDataObjectsArray = []
        _.forEach(this.allDataObjects, function (item, index) {
          self.handleDO(index, item, true)
        })
        if (this.selectedS && this.selectedS.id) {
          this.selectCopyItem(this.selectedS)
        } else {
          this.loadDO()
        }
      },
      unrelateAll() {
        let self = this;

        this.allDataObjects = []
        this.allDataObjectsFiltered = []

        if (this.selectedS && this.selectedS.id) {
          this.selectCopyItem(this.selectedS)
        } else {
          this.loadDO()
        }
      },
      updateDOList(selectedOption) {
        let self = this;
        let inArray = false;
        if (this.allDataObjects && this.allDataObjects.length) {
          _.forEach(this.allDataObjects, function (item, index) {
            if (item.id == selectedOption.id) {
              // if item is already in array
              item.related = true;
              self.$set(self.allDataObjects, index, item)
              inArray = true;
              self.allDataObjectsFiltered = _.cloneDeep(self.allDataObjects);
            }
          })
        }
        if (!inArray) {
          // If not in array, push it in array as related
          selectedOption.related = true;
          selectedOption.new_item = true;
          self.allDataObjects.push(selectedOption)
          self.allDataObjectsFiltered = _.cloneDeep(self.allDataObjects);
        }
      },
      removeDataItem(item, related) {

        // find indexes for both arrays
        let filteredIndex = _.findIndex(this.allDataObjectsFiltered, function(o) { return o.id == item.id; });
        let itemIndex = _.findIndex(this.allDataObjects, function(o) { return o.id == item.id; });

        // Remove item from data objects arrays
        this.allDataObjectsFiltered.splice(filteredIndex, 1);
        this.allDataObjects.splice(itemIndex, 1);

        if (this.selectedS && this.selectedS.id) {
          this.selectCopyItem(this.selectedS)
        } else {
          if (related == undefined) {
            this.loadDO()
          }
        }
      },
      confirmDeleteS(object) {
        let self = this;
        piincHttp.delete('third-parties/' + this.thirdParty.slug + '/subdata-processors/' + object.id).then(function() {
          self.hideSConfirmDeleteModal();
          self.loadSubdataProcessors();
          // Trigger toastr message after modal close
          self.$toastr('success', self.$t('maintenance.third_parties.sub_data_processors.delete.success'))
        }, function() {});
      },
      tpFormSubmit(evt) {

        let formData = new FormData();
        // Keep the reference in a variable
        // to use it inside function called when promise returned
        let self = this;
        evt.preventDefault();

        if (this.selectedVendor && this.selectedVendor.id) {
          formData.append("vendor_id", this.selectedVendor.id);
        }

        if (this.processingRole && this.processingRole.value) {
          formData.append("processing_role", this.processingRole.value);
        }

        // Append list of countries to FormData
        if (this.selectedCountries && this.selectedCountries.length) {
          for (var i = 0; i < this.selectedCountries.length; i++) {
            if (!this.selectedVendor || !this.selectedVendor.country || (this.selectedVendor && this.selectedVendor.country && this.selectedVendor.country != this.selectedCountries[i].name)) {
              formData.append("countries[]", this.selectedCountries[i].name);
            }
          }
        }

        if (this.processingRole && this.processingRole.value && this.selectedVendor && this.selectedVendor.id) {
          this.buttonDisabled = true;
          piincHttp.post('/third-parties/' + this.thirdParty.slug + '/subdata-processors', formData, {
            headers: {
              'Content-Type': 'multipart/form-data'
            }
          }).then(function(response) {
            self.$toastr('success', self.$t('maintenance.third_parties.sub_data_processors.create.success'))
            self.hideAddThirdPartyModal();
            self.buttonDisabled = false;
            self.loadSubdataProcessors();
            self.loadContent();
          }, function(error) {
            if (error.status !== 200) {
              self.buttonDisabled = false;
              self.error = error.data.message;
              if (error.data.errors.vendor_id) {
                self.error = self.$t('maintenance.third_parties.sub_data_processors.vendor_already_added_error')
              }
            }
          })
        } else {
          this.error = ''

          if (!this.selectedVendor || (this.selectedVendor && !this.selectedVendor.id)) {
            this.error +=  ' ' +  this.$t('maintenance.third_parties.sub_data_processors.vendor_error')
          }
          if (!this.processingRole || (this.processingRole && !this.processingRole.value)) {
            this.error +=  ' ' + this.$t('activities.third_party.create.processing_role_error')
          }

          this.buttonDisabled = false;
        }
      },
      dataMappingFormSubmit(evt) {
        let self = this;

        if (evt) {
          evt.preventDefault();
        }

        self.sForm.data_objects = []
        _.forEach(this.selectedDataObjects, function (dataObject) {
          if (dataObject.selected) {
            self.sForm.data_objects.push(dataObject.id)
          }
        })

        this.buttonDisabled = true;

        piincHttp.put('third-parties/' + this.thirdParty.slug + '/subdata-processors/' + this.itemObject.id,
          {
            data_objects: this.sForm.data_objects
          }
        ).then(function(response) {
          self.$toastr('success', self.$t('maintenance.third_parties.sub_data_processors.update.success'))
          self.$refs['data-mapping'].hide()
          self.copySystemItems = []
          self.$emit('updated');
          self.buttonDisabled = false;

        }, function(error) {
          if (error.status !== 200) {
            self.buttonDisabled = false;
            self.error = error.data.message;
          }
        })

      },
      loadContent() {
        let self = this;
        piincHttp.get('third-parties/' + this.thirdParty.slug, { params:
          {
            client: this.getClient.slug
          }
        }).then(function(response) {
          self.thirdParty = response.data;
        }, function() {});
      },
      loadSubdataProcessors(page, perPage) {
        let self = this;

        if (this.getStorePerPage) {
          this.selectedPerPage = this.getStorePerPage;
        }

        // If page is not defined, set page to default 1
        let pageNumber = page ? page : 1;
        let perPageNumber = perPage ? perPage : this.selectedPerPage;

        piincHttp.get('third-parties/' + this.thirdParty.slug + '/subdata-processors', { params:
          {
            client: this.getClient.slug,
            page: pageNumber,
            per_page: perPageNumber,
            sort: this.selectedSort !== '' ? this.selectedSort : undefined,
            order: this.selectedDirection !== '' ? this.selectedDirection : undefined,
          }
        }).then(function(response) {
          self.sTableItems = response.data.items;
          // Set number of total items
          self.totalRows = response.data.total_count;

          self.sLoading = false;
        }, function() {});
      },
      loadVendors(query) {
        let self = this;
        piincHttp.get('vendors', { params:
          {
            client: this.getClient.slug,
            parent: this.getClient.parent ? 1 : undefined,
            per_page: 100,
            search: query ? query : undefined
          }
        }).then(function(response) {
          self.vendors = response.data.items
        }, function() {});
      },
      loadCountries() {
        let self = this;
        piincHttp.get('countries-with-flag').then(function(response) {
          self.countries = response.data
        }, function() {});
      },
      loadDO(query, paginate) {
        let self = this;
        this.loading = true
        this.DOItems = []

        piincHttp.get('data-objects', { params:
          {
            client: this.getClient.slug,
            per_page: 200,
            page: this.page,
            keyword: query ? query : undefined
          }
        }).then(function(response) {
          self.DOItems = []
          let foundItem;

          _.forEach(response.data.items, function (item) {
            foundItem = _.find(self.selectedDataObjects, function(object) {
              return object.id == item.id
            });
            if (foundItem && foundItem.id) {
              item.selected = true
            }
            self.DOItems.push(item)
          })

          self.loading = false;
        }, function() {});
      },
    },
    created () {
      this.thirdParty = this.object;
      this.loadCountries();
      if (this.thirdParty && this.thirdParty.id) {
        this.showTable = true;
        this.loadTasks('update_subdata_processors');
        this.loadSubdataProcessors();
        //this.loadSR();
      }
      if (this.getClient && this.getClient.slug) {

      }

      this.loadGuides('update_subdata_processors');

    }
  }
</script>
